import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import TableAHSF from "../../Components/TableAHSF";
import PopupAHSF from "../../Components/PopupAHSF";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { useCookies } from "react-cookie";
import { GetSubTaskById } from "../../Redux/Reducers/SubTaskFlow";
import LoaderAHSF from "../../Components/LoaderAHSF";
import { GetMainTaskById } from "../../Redux/Reducers/TasksManager";
const TasksManagerPage = () => {
  const [cookies, setCookie] = useCookies([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let userInfoData = jwtDecode(cookies.loginTokenSSO);
  //this method to تشفير ال param
  const encodeParam = (param) => btoa(param);
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const [popUpBodyAddStatus, setpopUpBodyAddStatus] = useState(false);
  const [loading, setLoading] = useState(false);

  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];

  const RequestAccessor = [
    {
      KeyName: "flowName",
      ShowStatus: true,
      NmaeColumn: "المهمة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "flowName",
        keyValueName: "flowName",
      },
      DropdownFiltrationStatus: true,
      GroupOfColumns: false,
    },
    {
      KeyName: "taskStatusName",
      ShowStatus: true,
      NmaeColumn: "حالة المهمة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "taskStatusName",
        keyValueName: "taskStatusName",
      },
      DropdownFiltrationStatus: true,
      GroupOfColumns: false,
    },
    {
      KeyName: "projectName",
      ShowStatus: true,
      NmaeColumn: "اسم المشروع",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: "رقم الطلب",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "typeTask",
      ShowStatus: true,
      NmaeColumn: "نوع المهمة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "typeTask",
        keyValueName: "typeTask",
      },
      DropdownFiltrationStatus: true,
      GroupOfColumns: false,
    },
  ];
  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        setLoading(true);
        //to get subtask info  by taskId
        const GetSubTask = await dispatch(GetSubTaskById(e.target.value));
        //to get main task info  by taskId

        const GetMainTask = await dispatch(GetMainTaskById(e.target.value));
        console.log(GetSubTask, "GetSubTask.payload");
        //if subtask have value move it to sub task page
        if (GetSubTask.payload) {
            localStorage.setItem("aI_ApplicationInformationId_Manager", GetSubTask.payload?.applicationGUID)
          setLoading(false);
          navigate(
            `/grants/manager/AllComponentPage/${encodeParam(
              GetSubTask.payload?.taskFlow?.flowGUID
            )}/${encodeParam(e.target.value)}/${encodeParam(
              GetSubTask.payload?.taskFlow?.taskFlowGUID
            )}`
          );
        } else {
          // if main task have value move it to maintask page
          if (GetMainTask.payload) {
            console.log(GetMainTask.payload, "GetMainTask");
            localStorage.setItem("aI_ApplicationInformationId_Manager", GetMainTask.payload?.applicationGUID)

            navigate(
              `/grants/manager/AllComponentPageMainTask/${encodeParam(
                GetMainTask.payload?.flowGUID
              )}/${encodeParam(e.target.value)}/${encodeParam(
                GetMainTask.payload?.taskStatusGUID
              )}/${encodeParam(GetMainTask.payload?.uS_User?.uS_UserGuid)}`
            );
          }
        }
      },
      content: "",
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
  ];

  const RequestsManagerColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: <div></div>,

    title: "القطاعات الثانوية التي تمثل المشروع",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"taskGUID"}
        valueButtonAction={"taskGUID"}
        URL={`api/SubTaskFlow/GetAllTaskByUserId`}
        UrlBody={
          {
            // uS_UserGuid:
          }
        }
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={true}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
          />
        }
      />
      <LoaderAHSF show={loading} />
    </>
  );
};

export default TasksManagerPage;
